import { CLEAN_CARD, SAVE_CARD } from '../constants/actionTypes';

const INITIAL_STATE = {
  card: null,
};

const handleCard = (state, action) => ({
  ...state,
  card: action.payload,
});

const cardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SAVE_CARD:
      return handleCard(state, action);
    case CLEAN_CARD:
      return handleCard(state, action);
    default:
      return state;
  }
};

export default cardReducer;
